import { List, Collapse } from "antd";
import React from "react";
import { connect } from "react-redux";
import { setPropsMath } from "../../../redux/actions/appActions";
import { Bets, Images } from "../../";
import { setEvent } from "../../../redux/actions/sportEventsActions";
import { CountryCodes, AppConfig } from "../../../helpers";

import EventRow from "./EventRow";
import { ReactSVG } from "react-svg";
import { ManageMemeberFavorite } from "../../../redux/actions/membersActions";
import { updateFavoriteSportEvents } from "../../../redux/actions/sportEventsActions";
const { Panel } = Collapse;
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;
class Events extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sportEventsFilter:2,
      isFaviorite:
        this.props.sportEvent &&
        Object.values(this.props.sportEvent).length > 0 &&
        Object.values(this.props.sportEvent)[0].eventTournament.isFavorite
          ? true
          : false,
    };
    this.rowRenderer = this.rowRenderer.bind(this);
  }

  async componentDidMount() {
    const { match, setPropsMath } = this.props;
    setPropsMath(match);
  }

  async componentDidUpdate(prevProps) {
    const { match, setPropsMath, loadingSportEvents } = this.props;
    if (prevProps.loadingSportEvents !== loadingSportEvents) {
      this.setState({
        isFaviorite:
          this.props.sportEvent &&
          Object.values(this.props.sportEvent).length > 0 &&
          Object.values(this.props.sportEvent)[0].eventTournament.isFavorite
            ? true
            : false,
      });
    }
    setPropsMath(match);
  }

  getStartedEvents = () => {
    const { sportEvents } = this.props;
    return sportEvents ? sportEvents.filter((item) => item.isStarted) : null;
  };

  rowRenderer(item) {
    return <EventRow {...this.props} id={item} />;
  }
  onChange(key) {}
  // getCountryCode = (name) => {
  //   let result =
  //     this.props.countryFlags &&
  //     this.props.countryFlags.filter((element) => {
  //       return element.countryName.toLowerCase() == name.toLowerCase();
  //     });
  //   if (result && result.length > 0) {
  //     return result[0].countryFlagImagesName;
  //   }
  // };

  addToFavorate = (e, tournamentUId, fromTopBets = false , eventKey='' , isFaviorite=false ) => {
    e.stopPropagation();
    const { ManageMemeberFavorite, match, history ,updateFavoriteSportEvents} = this.props;
    const favItemKey = `2-${tournamentUId}-${match.params.sport}`;
    const memberFavorites =
      localStorage.getItem("memberFavorites") &&
      JSON.parse(localStorage.getItem("memberFavorites"));
    // if memberFavorites not exist then stop the function, else complete
    if (!memberFavorites) return;
    //
    const existingIndex = memberFavorites.findIndex(
      (item) => item.key === favItemKey
    );
    if (existingIndex > -1) {
      let element = memberFavorites.filter((item) => item.key == favItemKey);
      let data = {
        favoriteId: element[0].favoriteId,
        favoriteType: {
          favoriteTypeId: 2,
        },
        feedId: Number(match.params.feed),
        sportId: Number(match.params.sport),
        elementId: Number(tournamentUId),
      };
      ManageMemeberFavorite(data);
    } else {
      let data = {
        favoriteType: {
          favoriteTypeId: 2,
        },
        feedId: Number(match.params.feed),
        sportId: Number(match.params.sport),
        elementId: Number(tournamentUId),
      };
      ManageMemeberFavorite(data);
    }
    if (fromTopBets) {
      this.setState({
        [tournamentUId]: this.state[tournamentUId] ? undefined : tournamentUId,
      });
      updateFavoriteSportEvents(tournamentUId)
    } else {
      this.setState({
        isFaviorite: !this.state.isFaviorite,
      });
    }
  };
  setCurrentFilter =(filterType)=>{
    this.setState({
      sportEventsFilter:filterType
    })
  }

  render() {
    const {
      loadingSportEvents,
      title,
      eventsIds,
      match,
      sportEvent,
      signedIn,
    } = this.props;
    let filteredsportEvent = {};
    sportEvent &&
      Object.values(sportEvent).length > 0 &&
      Object.values(sportEvent).map((item) => {
        if (filteredsportEvent[item.eventTournament.tournamentId]) {
          let isDuplicate = true;
          filteredsportEvent[item.eventTournament.tournamentId].map(
            (element) => {
              if (element.eventBetLineNo !== item.eventBetLineNo) {
                isDuplicate = false;
              }
            }
          );
          !isDuplicate &&
            filteredsportEvent[item.eventTournament.tournamentId].push(item);
        } else {
          filteredsportEvent[item.eventTournament.tournamentId] = [];
          filteredsportEvent[item.eventTournament.tournamentId].push(item);
        }
      });

    const firstEvent =
      sportEvent &&
      Object.values(sportEvent).length > 0 &&
      Object.values(sportEvent)[0];
    if (loadingSportEvents) {
      return (
        <div className="events">
          {/* <div className="skeleton">
            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>

            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>

            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>

            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>
          </div> */}
          <div className="lds-parent-ring">
            <div className="lds-ring">
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="events">
        <div id="bits-filter" style={{ marginleft: "10px" }}>
          {eventsIds && eventsIds.length > 0 && (
            <>
              <Bets.EventsHeader {...this.props} title={title} isFromEventsSports={match.params.tournamentName} setCurrentFilter={this.setCurrentFilter} sportEventsFilter={this.state.sportEventsFilter}/>
            </>
          )}
        </div>
        <div id="bits-filter-rows">
          {/* {eventsIds &&
            eventsIds.map((item) => (
              <div className="event-row-parent-container" key={item}>
                <EventRow {...this.props} id={item} key={item} />
                </div>
            ))
          // <List
          // 	dataSource={eventsIds}
          // 	renderItem={this.rowRenderer}
          // />
          } */}
          {this.state.sportEventsFilter ==3 && sportEvent && Object.values(sportEvent).length == 0 && ` No Favorites Added `}
          {/* {match.params.countryName && match.params.tournamentName ? (
            <Collapse
              className="collaps"
              defaultActiveKey={["1"]}
              onChange={this.onChange}
            >
              <Panel
                header={
                  <>
                   {signedIn && (
                      <div className="star-container">
                        <ReactSVG
                          className={`${this.state.isFaviorite &&
                            `favorite-icon-selected`}`}
                          src={Images.LuckyNumberStar}
                          onClick={(e) =>
                            this.addToFavorate(
                              e,
                              firstEvent.eventTournament.tournamentUId,
                            )
                          }
                        />
                      </div>
                    )}
                    <div className="league">
                      <img
                        style={{
                          width: "25px",
                          height: "15px",
                          marginRight: "4px",
                        }}
                        src={
                          AppConfig.countryFlagImagesPath +
                          (match.params.categoryCode
                            ? match.params.categoryCode
                            : `eu`) +
                          `.webp`
                        }
                        alt="country-flag"
                      />
                      &nbsp;
                      <h2 className="heading-style">
                        {match.params.countryName}/{match.params.tournamentName}
                      </h2>
                    </div>
                  </>
                }
                key="1"
              >
                {eventsIds &&
                  eventsIds.map((item) => (
                    <div className="event-row-parent-container" key={item}>
                      <EventRow {...this.props} id={item} key={item} />
                    </div>
                  ))
                // <List
                // 	dataSource={eventsIds}
                // 	renderItem={this.rowRenderer}
                // />
                }
              </Panel>
            </Collapse>
          ) : (
            eventsIds &&
            Object.values(filteredsportEvent).length > 0 &&
            Object.values(filteredsportEvent).map((item, idx) => (
              <div className="event-row-parent-container" key={item + idx}>
                <Collapse
                  className="collaps"
                  defaultActiveKey={["1"]}
                  // onChange={this.onChange}
                >
                  <Panel
                    header={
                      <>
                        {signedIn && (
                          <div className="star-container">
                            <ReactSVG
                              className={`${
                                item[0].eventTournament.isFavorite
                                  ? `favorite-icon-selected`
                                  : ``
                              }`}
                              src={Images.LuckyNumberStar}
                              onClick={(e) =>
                                this.addToFavorate(
                                  e,
                                  item[0].eventTournament.tournamentUId,
                                  true,
                                  item[0].key,
                                  item[0].eventTournament.isFavorite
                                )
                              }
                            />
                          </div>
                        )}
                        <div className="league">
                          <img
                            style={{
                              width: "25px",
                              height: "15px",
                              marginRight: "4px",
                            }}
                            src={
                              AppConfig.countryFlagImagesPath +
                              (item[0].eventCategory.categoryFlagCode
                                ? item[0].eventCategory.categoryFlagCode
                                : `eu`) +
                              `.webp`
                            }
                            alt="country-flag"
                          />
                          <h2 className="heading-style">
                            {item.length > 0 &&
                              item[0].eventTournament.tournamentDisplayName}
                          </h2>
                        </div>

                      </>
                    }
                    key="1"
                  >
                    {item.map((element) => {
                      return (
                        <EventRow
                          {...this.props}
                          id={element.key}
                          key={element.key}
                        />
                      );
                    })}
                  </Panel>
                </Collapse>
              </div>
            ))
          )} */}
          {(
            eventsIds &&
            Object.values(filteredsportEvent).length > 0 &&
            Object.values(filteredsportEvent).map((item, idx) => (
              <div key={item + idx}>
                <Collapse
                  className="collaps"
                  defaultActiveKey={["1"]}
                  // onChange={this.onChange}
                >
                  <Panel
                    header={
                      <>
                        {signedIn && (
                          <div className="star-container">
                            <ReactSVG
                              className={`${
                                item[0].eventTournament.isFavorite
                                  ? `favorite-icon-selected`
                                  : ``
                              }`}
                              src={Images.LuckyNumberStar}
                              onClick={(e) =>
                                this.addToFavorate(
                                  e,
                                  item[0].eventTournament.tournamentUId,
                                  true,
                                  item[0].key,
                                  item[0].eventTournament.isFavorite
                                )
                              }
                            />
                          </div>
                        )}
                        <div className="league">
                          <img
                            style={{
                              width: "25px",
                              height: "15px",
                              marginRight: "4px",
                            }}
                            src={
                              AppConfig.countryFlagImagesPath +
                              (item[0].eventCategory.categoryFlagCode
                                ? item[0].eventCategory.categoryFlagCode
                                : `eu`) +
                              `.webp`
                            }
                            alt="country-flag"
                          />
                          <h2 className="heading-style">
                            {item.length > 0 &&
                              item[0].eventTournament.tournamentDisplayName}
                          </h2>
                        </div>

                      </>
                    }
                    key="1"
                  >
                    {item.map((element) => {
                      return (
                        <EventRow
                          {...this.props}
                          id={element.key}
                          key={element.key}
                        />
                      );
                    })}
                  </Panel>
                </Collapse>
              </div>
            ))
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (_, initialProps) => (state) => {
  return {
    sportEvent: state.sportEvents.sportEvents,
    loadingSportEvents: state.sportEvents.loadingSportEvents,
    eventsIds: state.sportEvents.eventsIds,
    countryFlags: state.general.countryFlags,
    signedIn: state.auth.signedIn,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setEvent: (item) => {
      dispatch(setEvent(item));
    },
    setPropsMath: (match) => {
      dispatch(setPropsMath(match));
    },
    ManageMemeberFavorite: (data) => {
      dispatch(ManageMemeberFavorite(data));
    },
    updateFavoriteSportEvents: (tournamentUId) => {
      dispatch(updateFavoriteSportEvents(tournamentUId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Events);
